export default "__VITE_ASSET__CefKpUx3__"